import React from 'react';
import { Layout } from "@/components/Layout/Layout";
import { useActiveRole } from '@/hooks/useActiveRole';
import { AdminDashboardView } from '../../components/common/Dashboard/AdminDashboardView';
import { StoreDashboardView } from '../../components/common/Dashboard/StoreDashboardView';
import { CommonCardSkeleton } from '@/components/ui/Loaders/DashboardSkeletons';
import { RootState, useAppSelector } from '@/redux/store';
import { usePermissions } from '@/hooks/usePermissions';

export default function DashboardPage() {
    const { roleId, rolesMap } = useActiveRole();
    const { isAdmin } = usePermissions()
    const user = useAppSelector((state: RootState) => state.user);

    // Show a loading skeleton while roles are loading
    if (!rolesMap) {
        return (
            <Layout>
                <div className="space-y-6 pb-20 animate-in fade-in duration-500">
                    <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
                        <div>
                            <h1 className="text-2xl font-bold text-foreground">Dashboard</h1>
                            <p className="text-sm text-muted-foreground">Yebo Eggs · Loading...</p>
                        </div>
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-5 gap-4">
                        {Array.from({ length: 10 }).map((_, i) => (
                            <CommonCardSkeleton key={i} />
                        ))}
                    </div>
                </div>
            </Layout>
        );
    }

    if (isAdmin) {
        return <AdminDashboardView />;
    }

    // Default to Store (Store Manager) Dashboard
    return <StoreDashboardView />;
}
